import React from 'react';
import Paragraph from '../../Paragraph';

export interface InlinePageTextProps {
    paragraph: string | React.ReactNode;
}

export default function InlinePageText({ paragraph }: InlinePageTextProps) {
    return (
        <div>
            <Paragraph variations={['no-margin']}>{paragraph}</Paragraph>
        </div>
    );
}

InlinePageText.calculateMaxHeightPercentage = function (): number {
    return 0.09;
};
